var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_691_383)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8948 34C27.2836 34 34.8948 26.3888 34.8948 17C34.8948 7.61116 27.2836 0 17.8948 0C8.50593 0 0.894775 7.61116 0.894775 17C0.894775 26.3888 8.50593 34 17.8948 34Z",
    fill: "#E8A941"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6667 10.3333V12.9999L17.6667 13.0543C17.6667 13.4784 17.6666 13.8905 17.7123 14.2304C17.7638 14.6136 17.8893 15.0509 18.2525 15.4141C18.6158 15.7773 19.053 15.9029 19.4362 15.9544C19.7761 16.0001 20.1883 16 20.6123 15.9999H20.6123L20.6667 15.9999H23.3334V19.6666C23.3334 21.5522 23.3334 22.495 22.7476 23.0808C22.1618 23.6666 21.219 23.6666 19.3334 23.6666H16.6667C14.7811 23.6666 13.8383 23.6666 13.2525 23.0808C12.6667 22.495 12.6667 21.5522 12.6667 19.6666V14.3333C12.6667 12.4476 12.6667 11.5048 13.2525 10.919C13.8383 10.3333 14.7811 10.3333 16.6667 10.3333H17.6667ZM19.6667 10.3592V12.9999C19.6667 13.4996 19.6689 13.7738 19.6944 13.9639L19.6954 13.9712L19.7027 13.9722C19.8929 13.9978 20.1671 13.9999 20.6667 13.9999H23.3074C23.2925 13.8912 23.269 13.7981 23.2319 13.7086C23.1304 13.4636 22.9377 13.2709 22.5524 12.8855L22.5524 12.8855L20.7811 11.1143C20.3958 10.7289 20.2031 10.5362 19.958 10.4347C19.8686 10.3977 19.7755 10.3742 19.6667 10.3592ZM15.0001 17.6666C15.0001 17.1143 15.4478 16.6666 16.0001 16.6666L20.0001 16.6666C20.5524 16.6666 21.0001 17.1143 21.0001 17.6666C21.0001 18.2189 20.5524 18.6666 20.0001 18.6666L16.0001 18.6666C15.4478 18.6666 15.0001 18.2189 15.0001 17.6666ZM16.0001 19.3333C15.4478 19.3333 15.0001 19.781 15.0001 20.3333C15.0001 20.8855 15.4478 21.3333 16.0001 21.3333H18.6667C19.219 21.3333 19.6667 20.8855 19.6667 20.3333C19.6667 19.781 19.219 19.3333 18.6667 19.3333H16.0001Z",
    fill: "#2B2C37"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_691_383"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 34,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExport);
export default __webpack_public_path__ + "static/media/icon-export.c6e09dafcdd96998c8ae35a8958bff67.svg";
export { ForwardRef as ReactComponent };